import styled from "styled-components"

import padding from "../global/padding"
import CardBase from "./Card"

export const Card = styled(CardBase)`
  margin-bottom: ${padding.small};
  height: 140px;
  text-transform: none;
`
